// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1687":"4e262121b33b4455","4044":"e3d725375b5799f6"}[chunkId] + ".css";
};